import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './DownloadCounter.css';

const DownloadCounter = ({ variant = 'default' }) => {
  const { t } = useTranslation();
  const count = 167;
  const isAnimating = false;

  // ОРИГИНАЛЬНАЯ ДИНАМИЧЕСКАЯ ЛОГИКА СЧЁТЧИКА (оставлена закомментированной):
  //
  // const [count, setCount] = useState(12450);
  // const [isAnimating, setIsAnimating] = useState(false);
  // const prevCountRef = useRef(12450);
  // const timeoutRef = useRef(null);
  //
  // useEffect(() => {
  //   const updateCounter = () => {
  //     const randomIncrement = Math.floor(Math.random() * 5) + 1;
  //     setCount(prev => {
  //       prevCountRef.current = prev;
  //       return prev + randomIncrement;
  //     });
  //     setIsAnimating(true);
  //     timeoutRef.current = setTimeout(() => setIsAnimating(false), 600);
  //   };
  //
  //   const interval = setInterval(() => {
  //     updateCounter();
  //   }, Math.random() * 3000 + 2000);
  //
  //   return () => {
  //     clearInterval(interval);
  //     if (timeoutRef.current) {
  //       clearTimeout(timeoutRef.current);
  //     }
  //   };
  // }, []);

  return (
    <div className={`download-counter download-counter-${variant}`}>
      <div className={`counter-icon ${isAnimating ? 'downloading' : ''}`}>
        <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
      </div>
      <div className="counter-content">
        <div className={`counter-inline ${isAnimating ? 'counting' : ''}`}>
          <span className="counter-value-inline">
            {count.toLocaleString('en-US')}+
          </span>
          <span className="counter-label-inline">
            {t('counter.label')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DownloadCounter;

